import * as React from 'react';
export const useFilteredColumns = (columns, storedColumns, setColumnConfig) => {
    const defaultState = columns
        .filter((column) => column.removable)
        .reduce((acc, current) => {
        const name = current.uniqueName ? current.uniqueName : current.name;
        acc[name] =
            storedColumns && storedColumns[name] !== undefined
                ? !storedColumns[name].hidden
                : current.defaultRemoveCheckedValue;
        return acc;
    }, {});
    const [filterState, setFilterState] = React.useState(defaultState);
    const filterChangeHandler = (name) => (event) => {
        const visible = event.target.checked;
        setFilterState({ ...filterState, [name]: visible });
        setColumnConfig(name, { hidden: !visible });
    };
    const columnChangeHandler = () => {
        setFilterState({ ...defaultState });
    };
    const filteredColumns = columns.filter((column) => filterState[column.uniqueName ? column.uniqueName : column.name] !== false);
    return [filteredColumns, filterState, filterChangeHandler, columnChangeHandler];
};
//# sourceMappingURL=useFilteredColumns.js.map